<div class="container exhibition_gallery_ban">
    <gallery [items]="images" thumb="false" thumbnails="false"></gallery>
</div>